import React from 'react';
import { Box, Button, Drawer, Grid, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import Employee, { Employees } from '@/types/Employee.type';
import HookFormControls, { HookFormControlsProps } from '../common/HookFormControls';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import EmployeeMyGroupService from '@/services/EmployeeMyGroup.service';
import LoadingButton from '@mui/lab/LoadingButton';

type Props = {
  myGroupId: string | number;
  employee: Array<Employee>;
  open: boolean;
  onClose: () => void;
};

const MyGroupDrawer: React.FC<Props> = ({ myGroupId, employee, open = false, onClose = () => {} }) => {
  const useFormMethods = useForm<Employees>({ shouldUnregister: false });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useFormMethods;

  const { enqueueSnackbar } = useSnackbar();

  const employees: HookFormControlsProps = {
    name: 'employees',
    type: 'autocomplete',
    label: '検索',
    options: employee,
    getOptionLabel: 'name',
    autocompleteProps: {
      multiple: true,
    },
    rule: {
      required: '社員は必須項目です。',
    },
  };

  const onSubmit = async (values: Employees) => {
    try {
      const employees = values.employees.map((employee: Employee) => {
        return employee['id'];
      });
      const requestValues = { ...{ employees: employees } };

      await EmployeeMyGroupService.create(requestValues, myGroupId);
      enqueueSnackbar(Messages.create.success, { variant: 'info' });
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 500, height: '100%' } }}>
      <Grid container sx={{ p: 3 }}>
        <Grid item xs={12} style={{ display: 'flex', width: '300px' }} marginTop="2rem">
          <Box style={{ fontSize: 'x-large', padding: '10px 0px' }}>メンバーの追加</Box>
        </Grid>
        <FormProvider {...useFormMethods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid item xs={12} style={{ width: '300px' }}>
                <HookFormControls {...employees} />
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        onClose();
                      }}
                    >
                      戻る
                    </Button>
                    <LoadingButton variant="contained" type="submit" color="primary" loading={isSubmitting}>
                      登録
                    </LoadingButton>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </Grid>
    </Drawer>
  );
};

export default MyGroupDrawer;
